//桌面快捷入口
var DesktopButton = xClass("DesktopButton", HomeSceneButton)

DesktopButton.prototype.ctor = function () {
    let self = this
    HomeSceneButton.prototype.ctor.call(self, "发送桌面", "homeicon/lobby_icon_desktop.png")
}

DesktopButton.prototype.onCick =  function () {
    let self = this
    function onSuccess() {
        //Toast.make("添加成功")
    }
    function onFail(desc) {
        // Toast.make("添加快捷失败")
    }
    GameProxy.getInstance().addShortcut(onSuccess, onFail)
}

module.exports = DesktopButton;
